import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { api_v3_list_of_tournaments } from "../utils/constants";
import { SlArrowRightCircle } from "react-icons/sl";
import axios from "axios";

const HallOfFamePage = () => {
  const [tournaments, setTournaments] = useState([]);

  useEffect(() => {
    axios
      .get(api_v3_list_of_tournaments())
      .then((response) => {
        const sorted = response.data.sort(
          (a, b) => new Date(a.startDate) - new Date(b.startDate)
        );
        setTournaments(sorted);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const groupByYear = (list) =>
    list
      .filter((t) => t.status === "finished" && t.type === "LEA")
      .reduce((acc, t) => {
        const year = t.startDate
          ? new Date(t.startDate).getFullYear()
          : "";
        if (!acc[year]) acc[year] = [];
        acc[year].push(t);
        return acc;
      }, {});

  const monthName = (dateString) => {
    const d = new Date(dateString);
    return d.toLocaleString("es-ES", { month: "long" }).replace(/^\w/, (c) => c.toUpperCase());
  };

  const groups = groupByYear(tournaments);

  return (
    <Canvas>
      <Content>
        <PageTitle>HALL OF FAME</PageTitle>
        <Subtitle>En breve añadiremos el resto de temporadas antiguas.</Subtitle>
        {Object.keys(groups).map((year) => (
          <YearSection key={year}>
            <YearHeader>{year}</YearHeader>
            <CardGrid>
              {groups[year].map((t) => (
                <Card key={t.tournamentId}>
                  <CardName>{t.name}</CardName>
                  <CardDate>
                    {monthName(t.startDate)} — {monthName(t.endDate)}
                  </CardDate>
                  {t.link && (
                    <CardLink to={t.link}>
                      VER MÁS <SlArrowRightCircle />
                    </CardLink>
                  )}
                </Card>
              ))}
            </CardGrid>
          </YearSection>
        ))}
      </Content>
    </Canvas>
  );
};

const Canvas = styled.div`
  background: var(--v-canvas);
  min-height: 100vh;
  display: flex;
  justify-content: center;
  padding: 4rem 1.5rem;
`;

const Content = styled.div`
  width: 100%;
  max-width: 900px;
`;

const PageTitle = styled.h1`
  font-family: Anton, sans-serif;
  font-size: clamp(48px, 8vw, 72px);
  font-weight: 400;
  text-transform: uppercase;
  line-height: 1;
  color: var(--v-fg);
  margin: 0 0 0.5rem;
`;

const Subtitle = styled.p`
  font-family: var(--v-font-body);
  font-size: 14px;
  color: var(--v-fg-muted);
  margin: 0 0 3rem;
`;

const YearSection = styled.div`
  margin-bottom: 3rem;
`;

const YearHeader = styled.h2`
  font-family: var(--v-font-mono);
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--v-fg-muted);
  margin: 0 0 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 0.75rem;
`;

const Card = styled.div`
  background: var(--v-surface);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  transition: border-color 0.15s ease;

  &:hover {
    border-color: rgba(60, 255, 208, 0.12);
  }
`;

const CardName = styled.h3`
  font-family: var(--v-font-body);
  font-size: 16px;
  font-weight: 600;
  color: var(--v-fg);
  margin: 0;
`;

const CardDate = styled.p`
  font-family: var(--v-font-mono);
  font-size: 10px;
  color: var(--v-fg-muted);
  margin: 0;
`;

const CardLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: auto;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--v-mint);
  text-decoration: none;
  padding: 0.5rem 0.85rem;
  border: 1px solid rgba(60, 255, 208, 0.2);
  border-radius: 24px;
  align-self: flex-start;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: rgba(60, 255, 208, 0.04);
    border-color: var(--v-mint);
  }

  svg {
    font-size: 14px;
  }
`;

export default HallOfFamePage;
